module.exports = __webpack_public_path__ + "img/sergeant-tips-icon3.59ac5537.png";